export default {
  subheading: 'Złóż swoje własne zamówienie',
  addCategory: 'Wybierz',
  addSubcategory: 'Dodaj do zamówienia',
  step1: 'Krok 1',
  step1Description: 'Wybierz kategorię produktów',
  step2: 'Krok 2',
  step2Description: 'Wybierz rodzaj przepakowania',
  step3: 'Krok 3',
  step3Description: 'Dowolnie skonfiguruj produkt',
  step4: '<b>Krok 4</b> (opcjonalnie)',
  step4Description: 'Wybierz dodatek do opakowania (gadżety dostarcza klient)',
  flavorsLeft: 'Pozostało różnych smaków',
  novelty: 'Nowość',
  anyConfig: 'smaki w dowolnej konfiguracji',
  maximum: 'maksymalnie',
  inPackage: 'w zestawie',
  checkPrice: 'Zobacz szacunkową cenę zestawu',
  noBonus: 'Brak dodatku',
  numberError: 'Dobierz maksymalną liczbę produktów',
  close: 'Zamknij',
  expand: 'Rozwiń',
};
